import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { CommonService } from './common.service';

@Injectable({ providedIn: 'root' })
export class ModalService {
  closeModalEvent = new EventEmitter();
  closeSpecialModalEvent = new EventEmitter();
  triggerModalFunctionEvent = new EventEmitter();

  private isCreateFolderModalVisible = new BehaviorSubject<boolean>(false);
  isCreateFolderModalVisible$ = this.isCreateFolderModalVisible.asObservable();

  private isEncryptedCreateFolderModalVisible = new BehaviorSubject<boolean>(false);
  isEncryptedCreateFolderModalVisible$ = this.isEncryptedCreateFolderModalVisible.asObservable();

  constructor(private commonService: CommonService) {}

  onCloseModal(): void {
    this.closeModalEvent.emit();
  }

  closeSpecialModal(modalId: string): void {
    // close a modal by id if visible
    this.closeSpecialModalEvent.emit(modalId);
  }

  closeModalManually(modalId: string): void {
    const modal = document.getElementById(modalId);
    if (modal) {
      this.closeModalEvent.emit();
      //  modal.style.display = 'none';
      modal.classList.remove('show');
      // document.body.classList.remove('modal-open');
      document.getElementsByClassName('modal-backdrop')[0]?.classList.remove('show');
      document.getElementsByClassName('modal-backdrop')[0]?.classList.remove('modal-backdrop');
    }
  }

  onTriggerModalFunction(fnName: string): void {
    this.triggerModalFunctionEvent.emit(fnName);
  }

  setCreateFolderModalVisibility(isVisible: boolean, modalId?: string): void {
    this.isCreateFolderModalVisible.next(isVisible);
    if (modalId) {
      setTimeout(() => {
        this.commonService.showModal(modalId);
      }, 0);
    }
  }

  setEncryptedCreateFolderModalVisibility(isVisible: boolean, modalId?: string): void {
    this.isEncryptedCreateFolderModalVisible.next(isVisible);
    if (modalId) {
      setTimeout(() => {
        this.commonService.showModal(modalId);
      }, 0);
    }
  }
}
